import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  user: { id: string; name: string; email: string; role: string } | null;
  tenant: { id: string; name: string; plan: string } | null;
  setAuth: (token: string, user: AuthState['user'], tenant: AuthState['tenant']) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      tenant: null,
      setAuth: (token, user, tenant) => set({ token, user, tenant }),
      logout: () => set({ token: null, user: null, tenant: null }),
    }),
    { name: 'samoplan-auth' },
  ),
);
